import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxFileUploaderModule, DxValidatorModule } from 'devextreme-angular';
import { FileDto } from '@services';
import { SignedLinkDirective } from 'src/app/directives/signed-link.directive';
import { MAX_FILE_SIZE } from 'src/app/shared/constants';
import notify from 'devextreme/ui/notify';
import { ValidationRule } from 'devextreme-angular/common';

@Component({
    selector: 'file-upload',
    imports: [
        CommonModule,
        DxFileUploaderModule,
        DxButtonModule,
        SignedLinkDirective,
        DxValidatorModule,
    ],
    templateUrl: './file-upload.component.html',
})
export class FileUploadComponent {
    @Input() label = '';
    @Input() value: File[] = [];
    @Input() maxFileSize = MAX_FILE_SIZE;
    @Input() maxFileNumber = 3;
    @Input() validators: ValidationRule[] = [];
    @Input() existingFiles: FileDto[] | null = null;
    @Input() filesToRemove: string[] = [];
    @Input() isReadOnly = false;

    @Output() valueChange = new EventEmitter<File[]>();
    @Output() existingFilesChange = new EventEmitter<FileDto[] | null>();
    @Output() filesToRemoveChange = new EventEmitter<string[]>();

    handleValueChanged(e: any) {
        const nextValue = Array.isArray(e?.value) ? e.value : [];
        const cappedValue =
            this.maxFileNumber > 0 && nextValue.length > this.maxFileNumber
                ? nextValue.slice(0, this.maxFileNumber)
                : nextValue;

        if (cappedValue.length !== nextValue.length) {
            notify({
                message:
                    'You can only upload a maximum of ' +
                    this.maxFileNumber +
                    ' files. The list has been truncated.',
                type: 'error',
                displayTime: 3000,
            });
        }

        this.value = cappedValue;
        this.valueChange.emit(cappedValue);
    }

    handleDelete(file: FileDto) {
        const nextExistingFiles = (this.existingFiles ?? []).filter(
            (item) => item.id !== file.id,
        );
        this.existingFiles = nextExistingFiles;
        this.existingFilesChange.emit(nextExistingFiles);

        const fileId = file?.id;
        if (typeof fileId === 'string' && fileId.trim().length > 0) {
            const nextFilesToRemove = Array.isArray(this.filesToRemove)
                ? [...this.filesToRemove]
                : [];
            if (!nextFilesToRemove.includes(fileId)) {
                nextFilesToRemove.push(fileId);
                this.filesToRemove = nextFilesToRemove;
                this.filesToRemoveChange.emit(nextFilesToRemove);
            }
        }
    }
}
